import {
  INursery,
  IResponseModalNurseryDashboard,
} from 'v2/resources/types/nurseries';

export const DEFAULT_RESPONSE_NURSERY: Array<INursery> = [
  {
    id: 0,
    capacity: 0,
    description: '',
    type: '',
    status: '',
    system: '',
    protocol: '',
  },
];

export const DEFAULT_RESPONSE_MODAL_NURSERY_DASHBOARD: IResponseModalNurseryDashboard =
  {
    id: 0,
    description: '',
    area: 0,
    type: '',
    system: '',
    protocol: '',
    status: '',
    begin: '',
    end: '',
    population: 0,
    density: 0,
    input_population: 0,
    specie_category: '',
    production: 0,
    survival_total_average: '',
    consumption: 0,
    totalFoodOffered: '',
    fca: 0,
    growingDays: 0,
    averageWeightGain: 0,
  };
